import { IInvoiceOperation } from "@/types/invoice-operation.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = `${import.meta.env.VITE_API_URL}/invoice-operation`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getInvoiceOperation({
  status = "",
  search = "",
  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "",
  fields = "companyId, customerId, status, type, dateEmission, items, amount, natureOperation, note",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  status && params.append("filters[status]", status);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString(),
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString(),
    );

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IInvoiceOperation[]
  > & { totalItems: number };

  return {
    ok: true,
    data: result.data,
    totalItems: result.totalItems,
  };
}

export async function getInvoiceOperationById(invoiceOperationId: string) {
  const url = `${API_URL}/${invoiceOperationId}`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<IInvoiceOperation>
  >;

  return result;
}

export async function createInvoiceOperation(invoiceOperationData) {
  const data = {
    ...invoiceOperationData,
    companyId: getCompanyId(),
  };
  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IInvoiceOperation>
  >;
}

export async function updateInvoiceOperation(
  id: string,
  updatedData: Omit<IInvoiceOperation, "companyId" | "dateEmission">,
) {
  const url = `${API_URL}/${id}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedData),
  };
  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IInvoiceOperation>
  >;

  return result;
}

export async function emitInvoiceOperation(id: string) {
  const url = `${API_URL}/${id}/emit`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  };
  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IInvoiceOperation>
  >;

  return result;
}

export async function cancellationInvoiceOperation(id: string, reason: string) {
  const url = `${API_URL}/${id}/cancel`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reason }),
  };
  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IInvoiceOperation>
  >;

  return result;
}
